import { createFileRoute } from "@tanstack/react-router";

import UserAttributesChangeForm from "./-components/UserAttributesChangeForm";

export const Route = createFileRoute("/_authenticated/settings/profile")({
  component: UserAttributesChangeForm,
});
